import styled, { css } from 'styled-components';
import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';

export const StyledList = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	border: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
	border-radius: 0.25rem;
	overflow: hidden;
`;

export const StyledHeader = styled.div`
	padding: 1.125rem 1rem;
	background-color: ${({ theme }) => theme.v2.color.neutral[100]};
`;

export const StyledFooter = styled.div`
	padding: 1.125rem 1rem;
	background-color: ${({ theme }) => theme.v2.color.neutral[100]};
	border-top: 1px solid ${({ theme }) => theme.v2.color.neutral[600]};
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const ListItem = styled.div<{ isSelected: boolean }>`
	display: flex;
	align-items: center;
	padding: 0.75rem 1rem;
	cursor: pointer;
	height: 5rem;
	border-bottom: 1px solid ${({ theme }) => theme.v2.color.neutral[200]};

	&:last-child {
		border-bottom: none;
	}

	${({ theme, isSelected }) =>
		isSelected
			? css`
					background-color: ${theme.v2.color.neutral[300]};
					${ItemTitle} {
						color: ${theme.v3.colors.blue[6]};
						font-weight: 600;
					}
					${ItemSubtitle} {
						color: ${theme.v2.color.neutral[800]};
					}
					border-right: 3px solid ${theme.v3.colors.blue[6]};
				`
			: css`
					&:hover {
						background-color: ${theme.v2.color.neutral[100]};
					}
					${ItemTitle} {
						color: ${theme.v2.color.neutral[1100]};
					}
					${ItemSubtitle} {
						color: ${theme.v2.color.neutral[600]};
					}
				`}
`;

export const SubtitleRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	width: 100%;
`;

export const ItemTitle = styled(TextV2)`
	user-select: none;
	font-size: 0.875rem;
	line-height: 1.25rem;
`;

export const ItemSubtitle = styled(TextV2)`
	user-select: none;
	font-size: 0.75rem;
	line-height: 1rem;
`;

export const ItemValue = styled(ItemSubtitle)`
	color: ${({ theme }) => theme.v2.color.neutral[1100]};
	font-weight: 500;
`;
